import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { withFirebase } from "react-redux-firebase";
import { signIn } from "../../store/actions/authActions";

class SignIn extends Component {
  state = {
    email: "",
    password: ""
  };

  handleChange = e => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.signIn(this.state, this.props.firebase);
    this.props.history.push("/");
  };

  render() {
    return (
      <div className="container">
      <form onSubmit={this.handleSubmit}>
        <div className="row">
          <div className="col s12">
            <div className="row">
              <div className="input-field col s12">
                <i className="material-icons prefix">email</i>
                <input
                  type="email"
                  id="email"
                  className="autocomplete"
                  required
                  onChange={this.handleChange}
                />
                <label htmlFor="email">Email Adress</label>
              </div>
              <div className="input-field col s12">
                <i className="material-icons prefix">vpn_key</i>
                <input
                  type="password"
                  id="password"
                  className="autocomplete"
                  required
                  onChange={this.handleChange}
                />
                <label htmlFor="password">Password</label>
              </div>
              <button className="btn waves-effect waves-light action button-login" type="submit">Login
                <i className="material-icons right">insert_emoticon</i>
              </button>
            </div>
          </div>
        </div>
      </form>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    signIn: (credentials, firebase) => dispatch(signIn(credentials, firebase))
  };
};

export default compose(
  withFirebase,
  withRouter,
  connect(
    null,
    mapDispatchToProps
  )
)(SignIn);
